<template>
    <div>
        <my-search @search="searchHandler" v-model="pgData" title-placeholder="标段名称/标段编号">
            <el-form-item slot="time"></el-form-item>
            <template slot="btn">
                <el-button type="success" icon="el-icon-plus" @click="addHandler">添加中标候选人公示</el-button>
            </template>
        </my-search>
        <my-table :data="tableData" :height="tableHeight">
            <el-table-column label="公示名称" prop="gsname" min-width="150" fixed="left"></el-table-column>
            <el-table-column label="公示编码" prop="gscode" min-width="150"></el-table-column>
            <el-table-column label="标段名称" prop="bdname" min-width="150"></el-table-column>
            <el-table-column label="公示类型" prop="gstypename" sortable width="110"></el-table-column>
            <el-table-column label="开始时间" prop="gsstarttime" sortable width="140"></el-table-column>
            <el-table-column label="结束时间" prop="gsendtime" sortable width="140"></el-table-column>
            <el-table-column label="提交时间" prop="gstjtime" sortable width="140"></el-table-column>
            <el-table-column label="状态" width="110">
                <template slot-scope="scope">

                    <template 
                    v-if="(isXt==='1'&&scope.row.shbj==='6')||scope.row.shbj==='6'">
                        <el-button type="text" 
                        icon="el-icon-refresh-right" 
                        @click="gettbzt(scope.row.gscode)">
                        查看公共服务平台同步结果</el-button>
                    </template>
                    <template v-else>
                    
                        <template v-if="scope.row.shbj==='5'">
                            <my-tag v-if="scope.row.xtts" type="primary">
                                交易中心待审核
                            </my-tag>
                            <my-tag v-else type="warning">
                                待推送交易中心
                            </my-tag>
                        
                        </template>
                        
                        <state-list 
                        v-else
                        :row="scope.row" 
                        :config="STATE_CONF">
                        </state-list>
                    </template>
        
                </template>
            </el-table-column>
            <el-table-column label="交易中心" width="180">
                <template slot-scope="scope">
                    <my-tag 
                    v-if="scope.row.processflag==='1'&&scope.row.dockflag==='1'&&(scope.row.pushstyle==='1'||scope.row.pushstyle==='2')&&scope.row.xtts==='1'&&scope.row.shbj==='6'"
                    type="success">
                        {{scope.row.extstr2}}交易中心审核通过
                    </my-tag>
                    
                    <el-tag v-if="!scope.row.xtts&&!scope.row.pushstyle">{{scope.row.extstr2}}</el-tag>
                    <jyzx-state v-if="scope.row.xtts||scope.row.pushstyle==='1'||scope.row.pushstyle==='2'" :data="scope.row"></jyzx-state>
                    
                    <push-type
                        v-if="isXt==='1'"
                        :column="scope.row" 
                        :pushPage="'zbhxrgs'" 
                        :primaryKey="scope.row.gscode"
                        :procode="getQuery('procode')">
                    </push-type>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="200" fixed="right">
                <template slot-scope="scope">
                    <btn-list 
                        :row="scope.row"
                        @reload="reloadHandler"
                        :config="BTN_CONF">
                    </btn-list>
                    
                </template>
            </el-table-column>
        </my-table>
        <my-pagination ref="page" v-model="tableData" :search="pgData" :action="`${getGetters('mngUrl')}/DingBiao/ZbHxrGs/get_list.json`">
        </my-pagination>

    </div>
</template>

<script>
import LIST_PAGE_MIXIN from '@views/mixins/list-page'
import { Loading } from 'element-ui';

import STATE_CONF from './config/state'
import BTN_CONF from './config/btn-list'
import JyzxState from '@views/bidding/components/jyzx-state'

import PushType from '@/components-sys/push-type'

export default {
    mixins: [LIST_PAGE_MIXIN],
    components: {
        PushType,JyzxState
    },
    data() {
        return{
            pgData:{
                procode:this.getQuery('procode'),
                sortname:'shbj',
                isXt:this.getQuery('isXt')
            },
            isXt:this.getQuery('isXt')||'',

            STATE_CONF,
            BTN_CONF,
        }
    },
    computed: {
        
    },
    watch: {

    },
    methods: {
        
        // 查看同步结果
        gettbzt(gscode){
            var that = this
            // 加载
            var loadingInstance = Loading.service({
                body : true,
                text : '加载中'
            });
            $.get(`${that.getGetters('mngUrl')}/manage/business/auditzbhxrgs/gettbzt.json`,{
                ggcode:gscode,
                isXt:that.getQuery('isXt'),
                t:Math.random(),
            }, (data, res) => {
                if(that.isXt==='1'){
                    if(data.result){
                        if((data.msg).indexOf('中标候选人公示开始时间小于当前时间')!=-1){
                            ShowConfirm(data.msg, 'warning', () => {
                                ShowConfirm('公共服务平台校验失败，是否退回该中标候选人公示？', 'danger', () => {
                                    that.$post(`${that.getGetters('mngUrl')}/manage/business/auditzbhxrgs/tuihui.json`, {
                                        gscode:gscode,
                                        isXt:that.getQuery('isXt')
                                    }, (data, res) => {
                                        loadingInstance.close()
                                        ShowMsg('退回成功', 'success');
                                        that.$emit('reload')
                                    });
                                })
                            })
                            
                        }else{
                            loadingInstance.close()
                            ShowMsgBox(data.msg,'info')
                        }
                    }
                }else{
                    loadingInstance.close()
                    ShowMsgBox(data.msg,'info')
                }
                
            })
        }
    },
    created() {
       
    },
    mounted() {
        
    }
}
</script>

<style scoped lang="scss">

</style>
